import { gql } from '@apollo/client'

const currentUserQuery = gql`
  query {
    currentUser {
      id
      roles
      access: MI6Access {
        hasAccess
        media
        library
        userManagement
        pageBuilder
        doclets
        images
        urlShortener
        communitiesMicrositesPermissions
        contentCuration
      }
      person {
        id
        firstName
        lastName
        photo {
          id
          cloudinaryId
        }
      }
    }
  }
`

export default currentUserQuery
